// Code-split barrel for components that should NOT ship in the initial JS
// bundle. Importing from here gives you `React.lazy()`-wrapped versions —
// wrap the consumer in `<Suspense fallback={<LoadingSpinner />}>`.
//
// Phase A: only the heavy interactive widgets are split. Phase B will add
// per-route splits when more pages exist.

import { lazy } from 'react';

/** @example
 *   import { Suspense } from 'react';
 *   import { BudgetCalculator } from '@/components/lazy';
 *   import LoadingSpinner from '@/components/feedback/LoadingSpinner';
 *
 *   <Suspense fallback={<LoadingSpinner />}>
 *     <BudgetCalculator />
 *   </Suspense>
 */
export const BudgetCalculator = lazy(() => import('./tools/BudgetCalculator'));
export const VisaChecklist = lazy(() => import('./tools/VisaChecklist'));
export const FriendlyNationsChecker = lazy(() => import('./tools/FriendlyNationsChecker'));
export const DogDocChecker = lazy(() => import('./tools/DogDocChecker'));
export const EuroUSDConverter = lazy(() => import('./tools/EuroUSDConverter'));
export const VisaWizard = lazy(() => import('./tools/VisaWizard'));
export const NeighborhoodQuiz = lazy(() => import('./tools/NeighborhoodQuiz'));
export const CostOfLivingComparator = lazy(() => import('./tools/CostOfLivingComparator'));
export const MortgageSimulator = lazy(() => import('./tools/MortgageSimulator'));
export const TaxSimulatorTerritorial = lazy(() => import('./tools/TaxSimulatorTerritorial'));
export const YouTubeEmbed = lazy(() => import('./media/YouTubeEmbed'));
export const PanamaGlobe = lazy(() => import('./widgets/PanamaGlobe'));
export const PanamaCanalScroll = lazy(() => import('./widgets/PanamaCanalScroll'));
export const PanamaFlightScroll = lazy(() => import('./widgets/PanamaFlightScroll'));
